function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';
import { FormattedMessage } from 'react-intl';
import isObjectLike from 'lodash/isObjectLike';
import { useSelector } from 'react-redux';
import App from 'modules/App';
import styles from './Steps.pcss';
const renderActiveStepOfSteps = (activeStep, totalSteps)=>/*#__PURE__*/ _jsx("div", {
        className: cn(styles.wheelStepper__text, 'text--h5'),
        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, App.messages.labels.activeStepOfSteps), {
            values: {
                activeStep,
                totalSteps
            }
        }))
    });
const renderMessage = (stepTemplate)=>{
    const { labelMessage } = stepTemplate;
    if (!labelMessage) {
        return null;
    }
    return isObjectLike(labelMessage) ? /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, labelMessage)) : labelMessage;
};
const renderStep = (stepTemplate, stepIdx, activeStepIdx, style)=>{
    const stepNumber = stepIdx + 1;
    return /*#__PURE__*/ _jsx("li", {
        className: "col",
        style: style,
        children: /*#__PURE__*/ _jsxs("div", {
            className: cn(styles.step, {
                [styles['step--active']]: stepIdx === activeStepIdx,
                [styles['step--done']]: stepIdx < activeStepIdx
            }),
            children: [
                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.labels.step)),
                " ",
                stepNumber,
                ":",
                ' ',
                /*#__PURE__*/ _jsx("b", {
                    children: renderMessage(stepTemplate)
                })
            ]
        })
    }, stepTemplate.id);
};
const Steps = ({ template, activeStepIdx = 0, shouldDisplayAlwaysAsSteps = true })=>{
    useStyles(styles);
    const steps = template.length;
    const widthIndicator = 100 / steps;
    const style = {
        flex: `0 0 ${widthIndicator}%`,
        maxWidth: `${widthIndicator}%`
    };
    const isMobileDisplayMode = useSelector(App.selectors.isMobileDisplayMode);
    const renderAsSteps = ()=>/*#__PURE__*/ _jsx("ul", {
            className: cn('row', styles.steps),
            children: template.map((stepTemplate, idx)=>renderStep(stepTemplate, idx, activeStepIdx, style))
        });
    const renderAsWheelStepper = ()=>{
        const totalSteps = template.length;
        const activeStep = activeStepIdx + 1;
        const percentage = activeStep / totalSteps * 100;
        return /*#__PURE__*/ _jsxs("div", {
            className: cn([
                styles.wheelStepperContainer,
                styles.mobileOnly
            ]),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.wheelStepper,
                    style: {
                        '--progress': `${percentage}%`
                    },
                    children: renderActiveStepOfSteps(activeStep, totalSteps)
                }),
                /*#__PURE__*/ _jsx("h5", {
                    className: "text--h3 text--medium",
                    children: renderMessage(template[activeStepIdx])
                })
            ]
        });
    };
    return shouldDisplayAlwaysAsSteps || !isMobileDisplayMode ? renderAsSteps() : renderAsWheelStepper();
};
export default Steps;
